import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Swipeable from 'react-swipeable';

const Circle = styled.div`
  border-radius: 100%;
  display: inline-block;
  height: 8px;
  width: 8px;
  &:not(:last-child) {
    margin: 0 5px 0 0;
  }

  background-color: ${p =>
    p.active
      ? p.theme.product.specs.circles.activeColor
      : p.theme.product.specs.circles.color};
  transition: background-color 240ms ease-in-out;
`;

const CircleWrapper = styled.div`
  display: none;
  margin: 8px 0 0 0;
  text-align: center;

  @media ${p => p.theme.media.largePhone} {
    display: block;
  }
`;

const Image = styled.img`
  flex: 1;
  max-width: 100%;
  max-height: 400px;
`;

const ImageWrapper = styled.div`
  padding: 0 1vw;
  text-align: center;

  @media ${p => p.theme.media.largePhone} {
    flex: 0 0 100%;
    padding: 0 10px;
    transition: 240ms transform ease-in-out;
    transform: translateX(${p => p.translate});
  }
`;

const Wrapper = styled.div`
  align-items: center;
  background-color: ${p => p.theme.product.specs.imagesBackground};
  display: flex;
  justify-content: ${p => (p.singleImage ? 'center' : 'space-between')};
  padding: 50px 2vw;
  overflow: hidden;

  @media ${p => p.theme.media.largePhone} {
    padding: 50px 0;
  }
`;

class Images extends React.PureComponent {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.string).isRequired
  };

  state = {
    active: 0
  };

  swipeLeft = () => {
    const max = this.props.images.length - 1;

    this.setState(state => ({
      active: state.active === max ? max : state.active + 1
    }));
  };

  swipeRight = () => {
    this.setState(state => ({
      active: state.active === 0 ? 0 : state.active - 1
    }));
  };

  render() {
    const { images } = this.props;
    const { active } = this.state;

    return (
      <div>
        <Swipeable
          onSwipedLeft={this.swipeLeft}
          onSwipedRight={this.swipeRight}
        >
          <Wrapper singleImage={images.length === 1}>
            {images.map((src, i) => (
              <ImageWrapper key={i} translate={`${-active * 100}%`}>
                <Image src={src} />
              </ImageWrapper>
            ))}
          </Wrapper>
        </Swipeable>
        <CircleWrapper>
          {images.map((_, i) => (
            <Circle key={i} active={active === i} />
          ))}
        </CircleWrapper>
      </div>
    );
  }
}

export default Images;
